import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { GenericModal, GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';
import { LogsProxy } from 'com-gyf-webcore-servicehub';

import errorHandler from '../../Common/Handlers/ErrorHandler';

import MenuProductos from '../MenuProductos/components/MenuProductos';
import MenuCategorias from '../MenuCategorias/Components/MenuCategoriasContainer';

const ProductosTitle = "PRODUCTOS";
const CambioContrasenaTitle = "cambiocontrasena";

import PopUpProducto from './PopUpProducto.jsx';
import PopUpPrograma from './PopUpPrograma.jsx';

/**
 * 
 * @param {any} props
 */
function getLocationProps(props) {
    const { pathname } = props.location;
    const splittedPathname = pathname.split('/');
    let productoActual = null;
    let categoriaActual = null;
    let programaActual = null;

    // /:product
    if (splittedPathname.length === 2)
        productoActual = (splittedPathname[1].trim() == "" ? null : splittedPathname[1]);

    // /:product/:category
    if (splittedPathname.length >= 3) {
        productoActual = (splittedPathname[1].trim() == "" ? null : splittedPathname[1]);
        categoriaActual = (splittedPathname[2].trim() == "" ? null : splittedPathname[2]);
        programaActual = (splittedPathname[3]) ? (splittedPathname[3].trim() == "" ? null : splittedPathname[3]) : null;
    }

    if (productoActual === null)
        productoActual = ProductosTitle;

    const result = {
        productoActual: productoActual,
        categoriaActual: categoriaActual,
        programaActual: programaActual
    }

    return result;
}

/**
 * Funcion que corrobora si el path es login.
 * @param {any} nextProps
 * @param {any} oldProps
 */
function isLogin(nextProps, oldProps) {
    return (
        oldProps.location.pathname !== '/login' &&
        nextProps.location.pathname !== '/login'
    );
}

class TopMenu extends Component {
    constructor(props) {
        super(props);
        let locationProps = getLocationProps(props);

        if (locationProps.productoActual.toLowerCase() === "login")
            locationProps.productoActual = ProductosTitle;

        this.state = {
            productoActual: locationProps.productoActual,
            categoriaActual: locationProps.categoriaActual
        }
    }

    changeProductFn(newProduct) {
        this.setState({ productoActual: newProduct });
    }

    componentDidMount() {
        //Activo errorHandler.
        errorHandler(this.props);
    }

    componentWillReceiveProps(nextProps) {
        const loggedIn = nextProps.loggedIn;

        if (loggedIn) {
            //Seteo el timer de inactividad si está logeado
            this.props.setTimerInactividad();

            if (this.props.menuProductos.primerLogin && !this.props.menuProductos.flagAccesoDirecto) {
                $("#productoModal").modal('hide');
            }
        }
        else {
            //Elimino el timer de inactividad si no está logeado
            this.props.deleteTimerInactividad();
        }

        const previouslyLoggedIn = this.props.loggedIn;
        const menuUsuario = nextProps.menuProductos.menuUsuario;

        const loginTransition = loggedIn && !previouslyLoggedIn;

        // El usuario paso de estar deslogueado a estar logueado y no hay productos en el menu actual.
        // Ir a buscar el menu.
        if (loginTransition)
            this.props.getMenuByUsuario(nextProps.userId);

        if (menuUsuario != undefined && menuUsuario != null && menuUsuario.length > 0) {
            if (isLogin(nextProps, this.props)) {
                const newProps = getLocationProps(nextProps);

                this.setState({
                    productoActual: newProps.productoActual,
                    categoriaActual: newProps.categoriaActual
                });

                if (newProps.productoActual.toLowerCase() != ProductosTitle.toLowerCase() && newProps.productoActual.toLowerCase() != CambioContrasenaTitle.toLowerCase()) {
                    this.props.getCategoriasByProducto(newProps.productoActual);
                }

                if (newProps.programaActual && newProps.programaActual != nextProps.menuProductos.lastProgram) 
                    this.props.setCurrentProgram(newProps.programaActual)                    
            }
        }

        if (this.props.menuProductos.startUpSelected &&
            this.props.menuProductos.startUpSelected.indexOf(nextProps.location.pathname) >= 0 &&
            nextProps.location.pathname && nextProps.location.pathname.length > 0 &&
            !this.props.menuProductos.flagAccesoDirecto) {
                window.location.href = this.props.menuProductos.startUpSelected;
        }
    }

    render() {
        if (!this.props.loggedIn)
            return null;

        const { productoActual, categoriaActual } = this.state;
        const { menuProductos } = this.props;
        const { globalState } = this.props;
        const { userId } = this.props;
        const { menuUsuario, menuLoaded } = menuProductos;

        if ((!menuUsuario || menuUsuario.length === 0) && menuLoaded)
            return (<div className='contenedor-mensaje-perfil'>
                <div>Permisos insuficientes</div>
                <div>El menu del usuario no tiene el formato correspondiente. Asigne los permisos correspondientes para poder continuar.</div>
                <div><button onClick={() => { this.props.cerrarSesion() }}>Volver a Login</button></div>
            </div>);
        else if (!menuUsuario || menuUsuario.length === 0)
            return (<div></div>);

        if (productoActual.toLowerCase().trim() === CambioContrasenaTitle.toLowerCase().trim() && menuLoaded)
            return (<div className='contenedor-mensaje-perfil'>
                <div>Permisos insuficientes</div>
                <div>El menu del usuario no tiene el formato correspondiente. Asigne los permisos correspondientes para poder continuar.</div>
                <div><button onClick={() => { this.props.cerrarSesion() }}>Volver a Login</button></div>
            </div>);
        else if (productoActual.toLowerCase().trim() === CambioContrasenaTitle.toLowerCase().trim())
            return (<div></div>);

        // No se eligio ningún producto. Por ende no existen los menues de producto.
        if (productoActual.toLowerCase().trim() === ProductosTitle.toLowerCase().trim()) {
            return (
                <div>
                    {(this.props.menuProductos.productosCount
                        && this.props.menuProductos.productosCount > 1) &&

                        <div>
                            <PopUpProducto
                            id={"productoModal"}
                            productos={menuProductos}
                            productoSelectedSave={this.props.productoSelectedSave}
                            productoSelected={this.props.productoSelected}
                            startUpSelected={this.props.menuProductos.startUpSelected}
                            productoId={this.props.menuProductos.productoId}
                            showPopUp={this.props.showPopUp}
                            showPopUpPrograma={this.props.showPopUpPrograma}
                            primerLogin={this.props.menuProductos.primerLogin}
                            flagAccesoDirecto={this.props.menuProductos.flagAccesoDirecto}
                            defaultProducto={this.props.menuProductos.defaultProducto}/>

                            <PopUpPrograma
                                id={"programaModal"}
                                productos={menuProductos}
                                programSelectionCancel={this.props.programSelectionCancel}
                                programaSelectedSave={this.props.programaSelectedSave}
                                programaSelected={this.props.programaSelected}
                                categorySelected={this.props.categorySelected}
                                startUpSelected={this.props.menuProductos.startUpSelected}
                                userId={this.props.userId}
                                defaultPrograma={this.props.menuProductos.defaultPrograma}/>
                        </div>
                    }

                    {(this.props.menuProductos.productosCount
                        && this.props.menuProductos.productosCount == 1) &&

                        <div>
                            <PopUpProducto
                            id={"productoModal"}
                            productos={menuProductos}
                            productoSelectedSave={this.props.productoSelectedSave}
                            productoSelected={this.props.productoSelected}
                            startUpSelected={this.props.menuProductos.startUpSelected}
                            productoId={this.props.menuProductos.productoId}
                            showPopUp={this.props.showPopUp}
                            showPopUpPrograma={this.props.showPopUpPrograma}
                            primerLogin={this.props.menuProductos.primerLogin}
                            flagAccesoDirecto={this.props.menuProductos.flagAccesoDirecto}
                            defaultProducto={this.props.menuProductos.defaultProducto}/>

                            <PopUpPrograma
                                id={"programaModal"}
                                productos={menuProductos}
                                programSelectionCancel={this.props.programSelectionCancel}
                                programaSelectedSave={this.props.programaSelectedSave}
                                programaSelected={this.props.programaSelected}
                                categorySelected={this.props.categorySelected}
                                startUpSelected={this.props.menuProductos.startUpSelected}
                                userId={this.props.userId}
                                defaultPrograma={this.props.menuProductos.defaultPrograma}/>
                        </div>
                    }
                    
                    <MenuProductos
                        productoActual={productoActual}
                        menuProductos={menuProductos}
                        globalState={globalState}
                        cerrarSesion={this.props.cerrarSesion}
                        userId={this.props.userId}
                        accesoDirectoPopUpPrograma={this.props.accesoDirectoPopUpPrograma}/>

                    {(this.props.menuProductos.startUpSelected && !this.props.menuProductos.flagAccesoDirecto) &&
                        (window.location.href = this.props.menuProductos.startUpSelected)
                    }
                </div>
            ); 
        }

        // Se eligio algún producto. Renderear el menú de producto y el submenu de categorías.
        return (
            <div>
                <MenuProductos
                    productoActual={productoActual}
                    menuProductos={menuProductos}
                    globalState={globalState}
                    cerrarSesion={this.props.cerrarSesion}
                    userId={this.props.userId}
                    accesoDirectoPopUpPrograma={this.props.accesoDirectoPopUpPrograma}/>
                <MenuCategorias
                    productoActual={productoActual}
                    categoriaActual={categoriaActual} />
            </div>
        );
    }
}

export default TopMenu;


// WEBPACK FOOTER //
// ./Portico/App/Screens/TopMenu/TopMenu.jsx